import React, { useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { FormHelperText, InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { map } from "ramda";
import { useCredentialTypes } from "../organizationServices";
import PropTypes from "prop-types";
import { notBlank } from "../../util/ext";

const CredentialTypeSelect = ({ onChange, onBlur, value, label, error, helperText }) => {
  const [credentialTypes, setCredentialTypes] = useState([]);
  const credTypeResponse = useCredentialTypes();
  useEffect(() => {
    if (credTypeResponse.isSuccess && notBlank(credTypeResponse.data)) {
      setCredentialTypes(credTypeResponse.data);
    }
  }, [credTypeResponse.isSuccess, credTypeResponse.data]);

  const handleChange = event => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth error={error}>
      <InputLabel htmlFor="credential-type">
        {label || "Credential Type"}
      </InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        inputProps={{
          name: "credential-type",
          id: "credential-type",
          onBlur: onBlur
        }}
      >
        {map(ct => {
          return (
            <MenuItem value={ct.id} key={ct.id}>
              {ct.displayName}
            </MenuItem>
          );
        }, credentialTypes)}
      </Select>
      {notBlank(helperText) && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

CredentialTypeSelect.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default CredentialTypeSelect;
